<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    width="600px"
  >
    <el-form
      :inline="true"
      :model="form"
      ref="form"
      label-width="85px"
      :rules="rules"
    >
      <el-form-item label="设备名称:" prop="deviceName">
        <el-input v-model="form.deviceName"></el-input>
      </el-form-item>
      <el-form-item label="设备类型:">
        <el-select
          v-model="form.deviceType"
          placeholder="请选择设备类型"
          style="width: 180px"
          prop="deviceType"
        >
          <el-option label="4G气象站" value="4G气象站"></el-option>
          <el-option
            label="CF8型智能气象站"
            value="CF8型智能气象站"
          ></el-option>
          <el-option label="WJ-A型气象站" value="WJ-A型气象站"></el-option>
          <el-option label="WJ-B型气象站" value="WJ-B型气象站"></el-option>
          <el-option label="其他型号气象站" value="其他型号气象站"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="MID:"
        v-if="form.deviceType === '4G气象站'"
        prop="device"
      >
        <el-input v-model="form.device"></el-input>
      </el-form-item>

      <el-form-item label="MAC:" v-else prop="device">
        <el-input v-model="form.device"></el-input>
      </el-form-item>
      <el-form-item label="设备ID:" prop="webId">
        <el-input
          v-model="form.webId"
          disabled
          placeholder="点击地图后自动生成"
        ></el-input>
      </el-form-item>
      <el-form-item label="安装地址:" prop="address">
        <el-input
          v-model="form.address"
          disabled
          placeholder="点击地图后自动生成"
          style="width: 460px"
        ></el-input>
      </el-form-item>
      <el-form-item label="经度:" prop="positionLng">
        <el-input
          v-model="form.positionLng"
          disabled
          placeholder="点击地图后自动生成"
        ></el-input>
      </el-form-item>
      <el-form-item label="纬度:" prop="positionLat">
        <el-input
          v-model="form.positionLat"
          disabled
          placeholder="点击地图后自动生成"
        >
        </el-input>
      </el-form-item>
      <div class="map">
        <el-amap
          vid="amapDemo"
          :plugin="plugin"
          :events="events"
          :center="center"
          :zoom="zoom"
        >
          <el-amap-marker
            v-if="center"
            :position.sync="center"
          ></el-amap-marker>
        </el-amap>
      </div>
      <el-form-item label="海拔高度:" style="margin-top: 20px">
        <el-input v-model="form.positionAlt"></el-input>
      </el-form-item>
      <el-form-item label="安装高度:" style="margin-top: 20px">
        <el-input v-model="form.mountAlt"></el-input>
      </el-form-item>

      <!-- 安装图片校验：添加了自定义校验提示逻辑 -->
      <el-form-item label="安装图片:" style="margin-top: 20px" required>
        <div style="display: flex">
          <div style="width: 150px">
            <el-upload
              class="avatar-uploader"
              action="https://kxwj.cn/server/common/upload"
              :show-file-list="false"
              :on-success="handleAvatarSuccess1"
              :before-upload="beforeAvatarUpload"
            >
              <img
                v-if="imageUrl1"
                :src="imageUrl1"
                class="avatar"
                style="width: 150px; height: 135px"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <el-select
              v-model="imageInfo[0].id"
              placeholder="请选择方位"
              style="margin-top: 10px"
              @change="handleChange"
            >
              <el-option
                v-for="item in columns2"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div style="width: 150px; margin-left: 40px">
            <el-upload
              class="avatar-uploader"
              action="https://kxwj.cn/server/common/upload"
              :show-file-list="false"
              :on-success="handleAvatarSuccess2"
            >
              <img
                v-if="imageUrl2"
                :src="imageUrl2"
                class="avatar"
                style="width: 150px; height: 135px"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <el-select
              v-model="imageInfo[1].id"
              placeholder="请选择方位"
              style="margin-top: 10px"
              @change="handleChange1"
            >
              <el-option
                v-for="item in columns2"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div
          v-if="imgError"
          style="
            color: #f56c6c;
            font-size: 12px;
            line-height: 1;
            padding-top: 4px;
          "
        >
          请上传两张安装图片并选择对应方位
        </div>
      </el-form-item>

      <el-form-item label="备注:">
        <el-input
          type="textarea"
          v-model="form.remarks"
          style="width: 460px"
        ></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import { $device } from "@/services";
export default {
  name: "addDeviceVue",
  data() {
    return {
      dialogVisible: false,
      imgError: false, // 图片校验错误标识
      form: {
        deviceName: "",
        deviceType: "CF8型智能气象站",
        webId: "",
        address: "",
        positionLng: "",
        positionLat: "",
        positionAlt: "",
        mountAlt: "",
        remarks: "",
      },
      title: "新增",
      center: [116.4, 39.9],
      zoom: 10,
      plugin: [
        {
          enableHighAccuracy: true,
          timeout: 100,
          convert: true,
          showButton: true,
          buttonPosition: "RB",
          showMarker: false,
          showCircle: false,
          panToLocation: true,
          zoomToAccuracy: true,
          extensions: "all",
          pName: "Geolocation",
          events: {
            init(o) {
              const that = this;
              o.getCurrentPosition((status, result) => {
                if (result && result.position) {
                  that.center = [result.position.lng, result.position.lat];
                  that.position = [result.position.lng, result.position.lat];
                  that.loaded = true;
                  that.zoom = 14;
                  that.$nextTick();
                }
              });
            },
          },
        },
      ],
      events: {
        click: (e) => {
          let that = this;
          this.center = [e.lnglat.lng, e.lnglat.lat];
          this.form.positionLng = e.lnglat.lng;
          this.form.positionLat = e.lnglat.lat;
          let url = `https://restapi.amap.com/v3/geocode/regeo?output=JSON&location=${[
            e.lnglat.lng,
            e.lnglat.lat,
          ]}&key=0ca7fee066a1fa548ebef6e4730fb4c9&extensions=base&batch=false`;
          axios
            .get(url)
            .then((res) => {
              that.form.address = res.data.regeocode.formatted_address;
              let time = new Date().getTime();
              that.form.webId =
                res.data.regeocode.addressComponent.towncode + time;
            })
            .catch((error) => {
              console.log(error);
            });
        },
      },
      rules: {
        deviceName: [
          { required: true, message: "请输入设备名称", trigger: "blur" },
        ],
        deviceType: [
          { required: true, message: "请选择设备类型", trigger: "blur" },
        ],
        device: [
          { required: true, message: "请输入设备标识", trigger: "blur" },
        ],
        webId: [{ required: true, message: "请点击地图", trigger: "blur" }],
        address: [{ required: true, message: "请点击地图", trigger: "blur" }],
        positionLng: [
          { required: true, message: "请点击地图", trigger: "blur" },
        ],
        positionLat: [
          { required: true, message: "请点击地图", trigger: "blur" },
        ],
      },
      imageUrl1: "",
      imageUrl2: "",
      imageInfo: [
        { id: "", name: "", file: [] },
        { id: "", name: "", file: [] },
      ],
      columns2: [
        { id: 1, label: "建筑物东部" },
        { id: 2, label: "建筑物西部" },
        { id: 3, label: "建筑物南部" },
        { id: 4, label: "建筑物北部" },
      ],
    };
  },
  computed: {
    // 映射 Vuex 中的用户信息，统一状态管理
    ...mapState({
      currentUserName: (state) => state.user.name,
      userId: (state) => state.user.userInfo?.id || "",
    }),
  },
  methods: {
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    handleAvatarSuccess1(res, file) {
      this.imageUrl1 = URL.createObjectURL(file.raw);
      let fileData = {
        message: "",
        size: file.size,
        status: "success",
        thumb: res.data.url,
        type: "image",
        url: res.data.url || res.data, // 兼容不同结构
      };
      this.$set(this.imageInfo[0].file, 0, fileData);
      this.checkImages();
    },
    handleAvatarSuccess2(res, file) {
      this.imageUrl2 = URL.createObjectURL(file.raw);
      let fileData = {
        message: "",
        size: file.size,
        status: "success",
        thumb: res.data.url,
        type: "image",
        url: res.data.url || res.data,
      };
      this.$set(this.imageInfo[1].file, 0, fileData);
      this.checkImages();
    },
    handleChange(e) {
      let item = this.columns2.find((item) => item.id === e);
      this.imageInfo[0].name = item ? item.label : "";
      this.checkImages();
    },
    handleChange1(e) {
      let item = this.columns2.find((item) => item.id === e);
      this.imageInfo[1].name = item ? item.label : "";
      this.checkImages();
    },
    // 专门用于校验图片的辅助方法
    checkImages() {
      const img1Valid = this.imageUrl1 && this.imageInfo[0].id;
      const img2Valid = this.imageUrl2 && this.imageInfo[1].id;
      this.imgError = !(img1Valid && img2Valid);
      return !this.imgError;
    },
    setFlag(data) {
      this.imgError = false;
      if (data) {
        this.title = "修改";
        this.$nextTick(() => {
          this.center = [data.positionLng, data.positionLat];
          data.device = data.mac;
          this.form = JSON.parse(JSON.stringify(data)); // 深拷贝防止污染

          if (data.imgInfo && data.imgInfo.length >= 2) {
            this.imageInfo = JSON.parse(JSON.stringify(data.imgInfo));
            this.imageUrl1 = this.imageInfo[0].file[0]?.url || "";
            this.imageUrl2 = this.imageInfo[1].file[0]?.url || "";
          } else {
            this.resetImageInfo();
          }
        });
      } else {
        this.title = "新增";
        this.form = {
          deviceName: "",
          deviceType: "CF8型智能气象站",
          webId: "",
          address: "",
          positionLng: "",
          positionLat: "",
          positionAlt: "",
          mountAlt: "",
          remarks: "",
        };
        this.resetImageInfo();
      }
      this.dialogVisible = true;
    },
    resetImageInfo() {
      this.imageUrl1 = "";
      this.imageUrl2 = "";
      this.imageInfo = [
        { id: "", name: "", file: [] },
        { id: "", name: "", file: [] },
      ];
    },
    submit() {
      // 1. 先进行表单基本规则校验
      this.$refs.form.validate((valid) => {
        // 2. 进行图片必传校验
        const isImgValid = this.checkImages();

        if (valid && isImgValid) {
          let params = { ...this.form };
          params.currentUserName = this.currentUserName;
          params.userId = this.userId;
          params.imgInfo = JSON.stringify(this.imageInfo);

          if (this.form.id) {
            params.deviceId = params.id;
            $device.upConnectData(params).then((res) => {
              if (res.result === 1) {
                this.$message.success("修改成功");
                this.$parent.getLessonListHelper();
                this.dialogVisible = false;
              }
            });
          } else {
            $device.setConnectData(params).then((res) => {
              if (res.result === 1) {
                this.$message.success("新增成功");
                this.$parent.getLessonListHelper();
                this.dialogVisible = false;
              }
            });
          }
        } else if (!isImgValid) {
          this.$message.error("请完整上传两张安装图片并选择对应方位");
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
:deep(.el-input__inner) {
  height: 30px;
}
:deep(.el-input__suffix) {
  top: 5px;
}
.map {
  margin: 0 auto;
  height: 200px;
  width: 90%;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 135px;
  line-height: 135px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
}
.avatar {
  border-radius: 4px;
  object-fit: cover;
}
</style>